module.exports = __webpack_public_path__ + "static/assets/9a1e0528994dd5bb6f907af348fa8ef2.png";